exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[data-v-b8dfce04]{position:relative}.icon[data-v-b8dfce04]{width:20px;height:20px;display:inline-block;margin-right:2px;position:absolute;transform:translateX(-25px) translateY(-2px)}.icon.favourited path[data-v-b8dfce04]{fill:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b8dfce04","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Account/favourite-button.vue
// module id = 3ZsO
// module chunks = 116